import { render, staticRenderFns } from "./Pa1.vue?vue&type=template&id=005843fd&scoped=true"
import script from "./Pa1.vue?vue&type=script&lang=js"
export * from "./Pa1.vue?vue&type=script&lang=js"
import style0 from "./Pa1.vue?vue&type=style&index=0&id=005843fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005843fd",
  null
  
)

export default component.exports